import { Button, Layout, Spin } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { useForm } from 'antd/es/form/Form'
import { get, put } from '../../Common/api'
import { t } from 'i18next'
import UserForm from '../UsersPage/UserForm'
import GlobalContext from '../GlobalContext'

export default function UserPage () {
  const { id } = useParams()
  const [form] = useForm()
  const [loading, setLoading] = useState(false)
  const [owners, setOwners] = useState([])
  const { notificationApi } = useContext(GlobalContext)

  useEffect(() => {
    getOwners()
    getUser()
  }, [])

  const getUser = async () => {
    setLoading(true)
    await get({
      url: `admin/users/${id}`,
      params: {},
      onSuccess: (json) => {
        setLoading(false)
        form.setFieldsValue(json)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const getOwners = async () => {
    setLoading(true)
    await get({
      url: 'admin/owners',
      params: {},
      onSuccess: (json) => {
        setLoading(false)
        setOwners(json)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const onFinish = (values) => {
    saveUser(values)
  }

  const saveUser = (params) => {
    setLoading(true)
    put({
      url: `admin/users/${id}`,
      params,
      notification: { api: notificationApi, state: 'update' },
      onSuccess: () => {
        setLoading(false)
      },
      onFailure: (errors) => {
        setLoading(false)
        form.setFields(
          Object.keys(errors).map((key) => ({
            name: key,
            errors: errors[key]
          }))
        )
      }
    })
  }

  return (
    <Layout style={{ padding: '1em', backgroundColor: 'white', marginTop: '2em' }}>
      <Spin spinning={loading}>
        <UserForm form={form} onFinish={onFinish} owners={owners} />
        <Button type="primary" htmlType="submit" onClick={form.submit}>
          {t('Admin.btn.submit')}
        </Button>
      </Spin>
    </Layout>
  )
}
